var $doc = $(document),
    $html = $("html"),
    $body = $("body");

(function($) {
    $body.removeClass("mod--preload");
    setTimeout(function () {
        $body.addClass("mod--loaded");
    }, 300);
})(jQuery);